class BoatWidgetShim {
  init = (clientId, divId, apiUrl, brandId) => {
    this.clientId = clientId;
    this.divId = divId;
    this.apiUrl = apiUrl;
    this.brandId = brandId;

    this.mountIframe();
  };
  mountIframe = () => {
    const iframe = document.createElement("iframe");
    iframe.onload = () => {
      this.iframe.contentWindow.postMessage({
        type: "INIT_IFRAME",
        value: { clientId: this.clientId },
      });
    };
    iframe.src = this.apiUrl + "/widget/booking/" + this.clientId + "?brandId=" + this.brandId;
    iframe.crossorigin = "anonymous";

    iframe.style.width = "100%";
    iframe.style.height = "100%";

    this.iframe = iframe;
    window.addEventListener("message", this.receiveMessage, false);
    var embedDiv = document.getElementById(this.divId);
    embedDiv.appendChild(this.iframe);
  };

  receiveMessage = (event) => {
    console.log(event)
    if (event.data.type === "resize") {
      document.getElementById(this.divId).style.height = `${event.data.height}px`;
    }
  };
  handleBootstrapDone = () => {
    const boatWidgetApi = window.weasl;
    boatWidgetApi._c = window.boatWidget._c;
    this.runPriorCalls();
    window.boatWidget = boatWidgetApi;
  };
  runPriorCalls = () => {
    console.log("running prior calls");
    window.boatWidget._c.forEach(([method, args]) => {
      console.log("running prior call", method, args);
      this[method].apply(this, args);
    });
  };
}
export default ((window) => {
  const stubSdk = window.boatWidget;

  const initCall = stubSdk._c.filter((call) => call[0] === "init");

  let brandId = "64b9748e320630a4eff2a216497dac08";
  if (initCall[0][1].length == 4) {
    brandId = initCall[0][1][3];
  }

  const shim = new BoatWidgetShim();
  stubSdk.init = shim.init;
  initCall && shim.init(initCall[0][1][0], initCall[0][1][1], initCall[0][1][2], brandId);
})(global);
